import Router from 'vue-router';
import Homepage from 'VIEW/homepage/index.vue';
import Introduction from 'VIEW/homepage/Introduction.vue';
import CloudPlan from 'VIEW/homepage/CloudPlan.vue';
import UserIndex from 'VIEW/user/index.vue';
import SubscribeIndex from 'VIEW/user/Subscribe/index.vue';
import SubScribeLock from '@/view/reolink/user/Subscribe/LockPlan/SubScribeLock.vue';
import LockPlanSelectSection from '@/view/reolink/user/Subscribe/LockPlan/components/LockPlanSelectSection.vue';
import SubscribeSim from '@/view/reolink/user/Subscribe/SIMPlan/SubscribeSim.vue';
import SimPlanSelectSection from '@/view/reolink/user/Subscribe/SIMPlan/components/SimPlanSelectSection.vue';
import InputSimCard from 'VIEW/user/Subscribe/SIMPlan/components/InputSimCard.vue';
import UpdateCloud from 'VIEW/user/Subscribe/CloudPlan/UpdatePlan.vue';
import UserDashboard from 'VIEW/user/dashboard/index.vue';
import MySimIndex from 'VIEW/user/MySim/index.vue';
import MyDeviceIndex from 'VIEW/user/MyDevice/index.vue';
import MyDevices from 'VIEW/user/MyDevices/index.vue';
import CloudLibrary from 'VIEW/user/library/index.vue';
import PaymentHistory from 'VIEW/user/paymentHistory/index.vue';
import Complete from '@/view/complete/index.vue';
import CancelPlansIndex from 'VIEW/user/cancelPlans/index.vue';
import CancelPlan from 'VIEW/user/cancelPlans/cancelPlan.vue';
import CancelPlanLegacy from 'VIEW/user/cancelPlans/cancelPlan-legacy.vue';
import CancelPlanComplete from 'VIEW/user/cancelPlans/cancelPlanComplete.vue';
import CheckoutIndex from 'VIEW/checkout/index.vue';
import Cart from 'VIEW/checkout/cart.vue';
import Pay from '../../view/cart/pay.vue';
import OrderComplete from 'VIEW/checkout/orderComplete.vue';
import ServiceRules from '@/view/termsOfUse/serviceRules.vue';
import ServiceRulesV1 from '@/view/termsOfUse/ServiceRulesV1.vue';
import SubscriptionTerms from '@/view/termsOfUse/SubscriptionTerms.vue';
import ContactUs from '@/view/termsOfUse/ContactUs.vue';
import NotFound from 'VIEW/404.vue';
import DoorbellSubscribePlan from 'VIEW/doorbell-subscribe-plan/index.vue';
import BindSuccess from '@/view/complete/bindSuccess.vue';
import Smarthome from '@/view/smarthome/index.vue';
import Callback from '@/view/callback/index.vue';
import AppFreePlan from '@/view/AppFreePlan/index.vue';
import simRules from '@/view/termsOfUse/simRules.vue';
import AiFeedback from '@/view/AiFeedback/index.vue';
import FreeSimPlanComplete from '@/view/reolink/user/Subscribe/SIMPlan/FreeSimPlanComplete.vue';
import { getQueryParam } from '@/common/js/utils';
import { pendingBindDevicesStorage } from '@/utils/business';

export default function ( context: any ): Record<string, { path: string;label: string; }> {

    return {

        homepage: {

            path: '/',
            label: context.$t( 'nav.homepage' )

        },

        dashboard: {

            path: '/user/dashboard/',
            label: context.$t( 'nav.dashboard' )

        },
        cloud: {

            path: '/user/cloud-library/',
            label: context.$t( 'nav.cloud' )

        },
        device: {
            path: '/user/my-devices/',
            label: context.$t( 'nav.devices' )
        }

    };

}

export const router = new Router({
    mode: 'history',
    scrollBehavior( to ) {

        if ( to.hash ) {

            return {

                selector: to.hash

            };

        }

    },
    routes: [
        {
            path: '/',
            component: Homepage,
            children: [
                {
                    name: 'introduction',
                    path: '/',
                    component: Introduction
                },
                {
                    name: 'cloud-plan',
                    path: 'cloud-plan',
                    component: CloudPlan
                }
            ]
        },
        {
            path: '/user',
            component: UserIndex,
            children: [
                {
                    path: 'subscribe-plan',
                    component: SubscribeIndex,
                    children: [
                        {
                            path: '/',
                            redirect: 'cloud/'
                        },
                        {
                            path: 'sim/',
                            name: 'sim',
                            component: SubscribeSim,
                            children: [
                                {
                                    path: '/',
                                    redirect: 'list/'
                                },
                                {
                                    path: 'list/',
                                    name: 'sim-plan-list',
                                    component: SimPlanSelectSection
                                },
                                {
                                    path: 'choose/',
                                    name: 'sim-plan-choose',
                                    component: SimPlanSelectSection,
                                    meta: { requiresAuth: true }
                                },
                                {
                                    path: 'select-sim/',
                                    name: 'select-sim-card',
                                    component: InputSimCard,
                                    meta: { requiresAuth: true }
                                }
                            ]
                        },
                        {
                            path: 'lock/',
                            name: 'lock',
                            component: SubScribeLock,
                            children: [
                                {
                                    path: 'choose/',
                                    name: 'lock-plan-choose',
                                    component: LockPlanSelectSection
                                },
                                {
                                    path: 'display/',
                                    name: 'lock-plan-display',
                                    component: LockPlanSelectSection,
                                    meta: { displayOnly: true }
                                },
                            ]
                        },
                        {
                            name: 'subscribe-cloud',
                            path: 'cloud',
                            redirect: {
                                name: 'cloud-plan'
                            }
                        },
                        {
                            name: 'update-cloud',
                            path: 'update-cloud',
                            component: UpdateCloud,
                            meta: { requiresAuth: true }
                        }
                    ]
                },
                {
                    path: 'update-plan',
                    redirect: 'subscribe-plan/update-cloud'
                },
                {
                    path: 'subscribe-view',
                    redirect: '/'
                },
                {
                    path: 'dashboard',
                    component: UserDashboard,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'my-sim',
                    component: MySimIndex,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'my-device',
                    component: MyDeviceIndex,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'my-sim/usage',
                    component: () => import( 'VIEW/user/MySim/Usage.vue' ), // Dynamic import for Usage.vue
                    meta: { requiresAuth: true }
                },
                {
                    path: 'my-devices',
                    component: MyDevices,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'cloud-library',
                    component: CloudLibrary,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'play/',
                    name: 'play',
                    component: () => import( 'VIEW/user/videos/index.vue' ), // Dynamic import for videos/index.vue
                    meta: { requiresAuth: true }
                },
                {
                    path: 'cloud-plan-payment-history',
                    component: PaymentHistory,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'invoice/:id/',
                    component: () => import( 'VIEW/user/paymentHistory/invoice.vue' ),
                    meta: { requiresAuth: true }
                },
                {
                    path: 'complete',
                    component: Complete,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'bind-success',
                    name: 'bindSuccess',
                    component: BindSuccess,
                    meta: { requiresAuth: true }
                },
                {
                    path: '/user/cancel-plan/',
                    component: CancelPlansIndex,
                    children: [
                        {
                            path: '/',
                            name: 'cancelPlan',
                            component: CancelPlan,
                            meta: { requiresAuth: true }
                        },
                        {
                            path: 'legacy/',
                            name: 'cancelPlan-legacy',
                            component: CancelPlanLegacy,
                            meta: { requiresAuth: true }
                        },
                        {
                            path: 'complete/',
                            name: 'cancelPlanComplete',
                            component: CancelPlanComplete,
                            meta: { requiresAuth: true }
                        }
                    ]
                }
            ]
        },
        {
            path: '/checkout',
            component: CheckoutIndex,
            children: [
                {
                    path: '/',
                    name: 'cart',
                    component: Cart,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'pay/',
                    name: 'pay',
                    component: Pay,
                    meta: { requiresAuth: true }
                },
                {
                    path: 'payment-complete/',
                    name: 'orderComplete',
                    component: OrderComplete,
                    meta: { requiresAuth: true }
                }
            ]
        },
        {
            path: '/terms-of-use/',
            name: 'serviceRules',
            component: ServiceRules
        },
        {
            path: '/terms-of-use-v1/',
            name: 'serviceRulesV1',
            component: ServiceRulesV1
        },
        {
            path: '/doorbell-subscribe-plan/',
            name: 'doorbellSubscribePlan',
            component:DoorbellSubscribePlan,
            meta: { requiresAuth: true }
        },
        {
            path: '/subscription-terms/',
            name: 'subscriptionTerms',
            component: SubscriptionTerms
        },
        {
            path: '/ulink/smarthome/:info*',
            name: 'smarthome',
            component: Smarthome
        },
        {
            path: '/ulink/*',
            name: 'ulink',
            component: Callback
        },
        {
            path: '/app-free-plan',
            name: 'AppFreePlan',
            component:AppFreePlan,
            meta: { noIndex: true }
        },
        {
            path: '/app-cellular-data-service/',
            name: 'simRules',
            component: simRules,
            meta: { noIndex: true }
        },
        {
            path: '/ai-feedback',
            name: 'aiFeedback',
            component: AiFeedback,
            meta: { noIndex: true }
        },
        {
            path: '/free-sim-complete',
            name: 'freeSimPlanComplete',
            component: FreeSimPlanComplete,
            meta: { requiresAuth: true }
        },
        {
            path: '/contact-us',
            name: 'contactUs',
            component:ContactUs,
        },
        {
            path: '*',
            name: '404',
            component: NotFound
        },
        {
            path: '/cloud-storage-renewal-deals',
            name: 'cloudStorageRenewalDeals',
            component: () => import( '@/view/Activity/index.vue' )
        }
    ]
});

router.beforeEach(( to, _from, next ) => {

    const pendingBindDevices = getQueryParam( to, 'pending_bind_device' );
    if ( ['cloud-plan', 'cart'].includes( to.name ?? '' ) && pendingBindDevices.length ) {

        pendingBindDevicesStorage.setItem( 'pendingBindDevices', pendingBindDevices );

    }
    next();

});
